<template>
  <div class="customer-login">
    <h3 class="title">管理员登录</h3>
    <p class="tips"></p>
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-position="top"
      hide-required-asterisk
      v-loading="loading"
    >
      <el-form-item
        label="账号"
        prop="username"
      >
        <el-input
          placeholder="请输入"
          v-model.trim="form.username"
          name="username"
          class="w-full">
        </el-input>
      </el-form-item>
      <el-form-item
        prop="password"
        class="password-form-item"
      >
        <p class="text-p display-flex space-between">
          <span>密码</span>
        </p>
        <el-input
          type="password"
          placeholder="密码"
          v-model.trim="form.password"
          show-password
          @keyup.enter.native="loginHandle"
          class="w-full"></el-input>
      </el-form-item>
      <el-form-item
        label="验证码"
        prop="captcha"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="captcha-box"
                 style="height: 50px"
            >
              <el-input
                style="height: 100%"
                v-model.trim="form.captcha"
                placeholder="验证码"
                @keyup.enter="loginHandle"
              >
              </el-input>
            </div>
          </el-col>
          <el-col :span="12" class="login-captcha">
            <img
              class="captcha-el pointer"
              :src="captchaPath"
              @click="getCaptcha()"
              alt=""
            >
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item>
        <vs-button
          class="w-full mt-6 vs-button-outer"
          type="filled"
          size="large"
          @click="loginHandle"
        >登录</vs-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import  { getUUID } from '@/utils/index'
import { LoginPost } from '@/api/user'
export default {
  name: "customerLogin",
  data() {
    return {
      uuid:'',
      form:{
        username: '',
        password: '',
        captcha: '',
      },
      rules:{
        username: [
          { required: true, message: '请输入您的账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入您的密码', trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
      },
      loading: false,
      captchaPath: '',
    }
  },
  created(){
    this.getCaptcha();
  },
  methods: {
    loginHandle(){
      this.$refs.form.validate((valid) => {
        if(valid){
          localStorage.clear();
          this.loading = true;
          LoginPost({
            username: this.form.username,
            password: this.form.password,
            uuid: this.uuid,
            captcha: this.form.captcha,
            // googleKey: this.form.dynamicpassword,
          }).then((res) => {
            if(res && res.code !== 200){
              this.$vs.notify({
                title: '注意',
                text: res.msg,
                position:'top-center',
                color: 'warning',
              });
            }else {
              localStorage.setItem('userName',this.form.username);

              localStorage.setItem('token',res.token);
              /*if (this.$route.query.redirectRouterName) {
                this.$router.push({ name: this.$route.query.redirectRouterName, parmas: this.$route.params });
              } else {
                //custType 客户类型  1:个人代理  2:企业代理  3:直客


              }*/
              //每个账户登录都要清除之前的tagView,登录之后跳到home页面
              this.$store.dispatch('delAllViews');
              this.$router.push({
                name: 'home'
              }).catch((err) => {
                console.log(err);
              });
            }
            this.loading = false;

          }).catch((error) => {
            this.loading = false;
            this.getCaptcha();
            this.$emit('login-failed');
          })
        }
      });
    },
    // 获取验证码
    getCaptcha() {
      this.uuid = getUUID();
      this.captchaPath = process.env.VUE_APP_API + `/wx/captcha?uuid=${this.uuid}`;
    }
  },
}
</script>

<style lang="scss" scoped>
.customer-login {
  /deep/ .el-input__inner {
    border: 1px solid #D8D6DE;
    border-radius: 5px;
  }
  /deep/ .el-form-item__content {
    line-height: 10px;
  }
  /deep/ .el-form-item {
    margin-bottom: 15px;
  }
  /deep/ .el-form-item__label {
    padding-bottom: 5px;
    line-height: 14px;
  }
  .text-p {
    margin-bottom: 7px;
    margin-top: 7px;
  }
  .tips {
    margin-bottom: 40px;
    margin-top: 10px;
  }
  .vs-button-outer {
    button {
      //font: none;
    }
  }
  .captcha-el {
    height: 40px;
    //width: 100%;
  }
}
</style>
